import { i18n } from "@/locales";
import { acceptHMRUpdate, defineStore } from "pinia";
import { ref, watch } from "vue";
import { useLocale } from "vuetify";

export const ThemeEnum = {
  light: "Light",
  lightgreen: "Light Green",
  dark: "Dark",
};

export const LanguageEnum = {
  en: "English",
  cs: "Czech",
};

export type Theme = keyof typeof ThemeEnum;
export type Language = keyof typeof LanguageEnum;

export const useSettingsStore = defineStore(
  "settings",
  () => {
    const theme = ref<Theme>("lightgreen");
    const language = ref<Language>("en");
    const defaultFormatting = ref<any>({});
    const { current: currentVuetifyLocale } = useLocale();

    defaultFormatting.value = {
      date: i18n.global.getLocaleMessage(language.value)["date"]["defaultFormats"],
    };

    watch(language, () => {
      currentVuetifyLocale.value = language.value;

      defaultFormatting.value = {
        date: i18n.global.getLocaleMessage(language.value)["date"]["defaultFormats"],
      };
    });

    return { theme, language, defaultFormatting };
  },
  {
    persist: true,
  }
);

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSettingsStore, import.meta.hot));
}
